import { post, get, put, del } from '@api/request';

export const search = async (
  { mobileService },
  authenticationToken,
  { payload },
) => {
  let url = `${mobileService}/mobile/assignment/search`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export async function fetchSearchParams(
  { mobileService },
  authenticationToken,
  { userName },
) {
  const queryParam = userName ? `?userName=${userName}` : '';
  const url = `${mobileService}/mobile/assignments/searchparameters${queryParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSearchParam(
  { mobileService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${mobileService}/mobile/assignments/searchparameter/${searchParamID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertSearchParam(
  { mobileService },
  authenticationToken,
  { payload },
) {
  const url = `${mobileService}/mobile/assignments/searchparameters`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateSearchParam(
  { mobileService },
  authenticationToken,
  { searchParamID, payload },
) {
  const url = `${mobileService}/mobile/assignments/searchparameter/${searchParamID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function duplicateSearchParam(
  { mobileService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${mobileService}/mobile/assignments/searchparameter/${searchParamID}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function deleteSearchParam(
  { mobileService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${mobileService}/mobile/assignments/searchparameter/${searchParamID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function deleteAssignment(
  { mobileService },
  authenticationToken,
  { mobileAssignmentID },
) {
  const url = `${mobileService}/mobile/assignment/${mobileAssignmentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
